import BaseModel from '../../base';

import constants from './constants';
import glossary from './glossary';

export default class AssociationUserRestriction extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.allowed_values = item.allowed_values || [];
    this.event_association_id = item.event_association_id;
    this.event_global_attribute_id = item.event_global_attribute_id;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
